import { SelectItem } from 'vet-bones/utils/select';

import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import {
  MappingIdentifier,
  MappingIdentifierPart,
  MappingIdentifierType,
} from 'src/containers/ProjectDiagram/types/data';
import { ProjectResource } from 'src/store/state/projects';
import {
  MappingFilterCheckState,
  MappingFilterType,
} from 'src/store/ui/constants';

export const enum SuggestionType {
  'CLASS' = 'CLASS',
  'ATTRIBUTE' = 'ATTRIBUTE',
  'LABEL' = 'LABEL',
  'PRIMARY_IDENTIFIER' = 'PRIMARY_IDENTIFIER',
  'RELATIONSHIP' = 'RELATIONSHIP',
}

type BaseSuggestion<T extends SuggestionType> = {
  /** column */
  field: string;
  rejected?: boolean;
  resource: ProjectResource;
  /** between 0.0 and 1.0 */
  score: number;
  selected?: boolean;
  type: T;
};

export type ClassSuggestion = Omit<
  BaseSuggestion<SuggestionType.CLASS>,
  'field'
> & {
  iri: string;
  label?: string;
  source?: string;
};

export type AttributeSuggestion = BaseSuggestion<SuggestionType.ATTRIBUTE> & {
  iri: string;
  label?: string;
  propertyType?: string;
  classIri: string;
  classLabel?: string;
};

export type RelationshipSuggestion = Omit<
  BaseSuggestion<SuggestionType.RELATIONSHIP>,
  'field'
> & {
  iri: string;
  fields: MappingIdentifierPart[];
  label?: string;
  propertyType?: string;
  propertyTypeLabel?: string;
  classIri: string;
  classLabel?: string;
  direction: RelationshipDirection;
};

export type LabelSuggestion = BaseSuggestion<SuggestionType.LABEL> & {
  source?: string;
};

export type PrimaryIdentifierSuggestion = Omit<
  BaseSuggestion<SuggestionType.PRIMARY_IDENTIFIER>,
  'field'
> & { fields: MappingIdentifierPart[]; source?: string };

export type Suggestion =
  | ClassSuggestion
  | AttributeSuggestion
  | LabelSuggestion
  | PrimaryIdentifierSuggestion
  | RelationshipSuggestion;

export type MappingFilterItem = SelectItem & {
  value: string | MappingFilterType;
  checkState: MappingFilterCheckState;
};

export type RelationshipMappingCell = {
  classIri: string | null;
  classMappingIdentifier: MappingIdentifier;
  isSource: boolean; // whether cell says "Source Identifier" or "Target Identifier" (opposing class)
  mappingId: string;
  relationshipMappingKey: string | null;
};

export type MultiSelectIdentifierItem = SelectItem & {
  type: MappingIdentifierType;
};
